module.exports = __webpack_public_path__ + "img/betamount_icon.92d0788b.svg";